// Small yellow badge in the header showing total transaction count.
// Alerts if count drops via a compact banner below the header.
import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useHeaderExtrasEffect } from "@/context/HeaderExtras";

const KEY = "malat_tx_last_count";

export function TxTotalCounter() {
  const { lang } = useI18n();
  const AR = lang === "ar";
  const [count, setCount] = useState(null);
  const [drop, setDrop] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const refresh = () => {
    api.get("/transactions/stats").then((r) => {
      const c = r.data?.total_count || 0;
      const last = Number(localStorage.getItem(KEY) || 0);
      if (last > c && last - c >= 1) setDrop({ from: last, to: c });
      setCount(c);
      localStorage.setItem(KEY, String(c));
    }).catch(() => {});
  };

  useEffect(() => {
    refresh();
    const on = () => refresh();
    window.addEventListener("malat:data-changed", on);
    return () => window.removeEventListener("malat:data-changed", on);
  }, []);

  useHeaderExtrasEffect(
    count === null ? null : (
      <span data-testid="tx-total-badge"
        className="px-3.5 py-1.5 rounded-lg text-base font-extrabold tabular-nums bg-amber-300 text-amber-900 shadow-sm"
        style={{ boxShadow: "0 2px 8px rgba(202,138,4,0.4)" }}>
        {count.toLocaleString()}
      </span>
    ),
    [count],
  );

  if (!drop || dismissed) return null;
  return (
    <div data-testid="tx-drop-alert" className="p-3 rounded-2xl border-2 border-rose-300 bg-rose-50 flex items-center gap-2.5">
      <AlertTriangle className="w-5 h-5 text-rose-600 animate-pulse shrink-0" />
      <p className="flex-1 text-xs font-bold text-rose-700 leading-snug">
        {AR
          ? `تنبيه: عدد المعاملات نقص من ${drop.from} إلى ${drop.to}. تحقق قبل أن تفقد بيانات.`
          : `Alert: transaction count dropped from ${drop.from} to ${drop.to}. Investigate.`}
      </p>
      <button data-testid="drop-dismiss" onClick={() => setDismissed(true)}
        className="w-7 h-7 grid place-items-center rounded-lg text-rose-600 active:scale-95"><X className="w-4 h-4" /></button>
    </div>
  );
}
